import * as types from 'models/actionTypes'
import { push } from 'connected-react-router'
import qs from 'qs'

import * as tracker from 'utils/tracker'
import { FURNITURE_ITEM } from 'constants/renderItemTypes'
import {
    getHash,
    getSearch,
    getDebugFurnitureId,
    getDefaultRedirectUrl,
    getDebugFurnitureModelUrl,
    getApiPrefix,
    getDesignLabReturnUrl,
    getIsIFrame,
    getPathRegion,
    getSaveOnFirstRender,
} from 'models/location/selectors'
import { makeLoginUrl } from 'models/location/helpers'
import { getSelectedId } from 'models/scenes/selectors'
import { getCompositionsData } from 'models/compositions/selectors'
import { clickPlaceRenderItem } from 'models/compositions/actions'
import { saveSelectedCompositionToLocalStorage } from 'models/localStorage/actions'
import { reset } from 'utils/tracker'
import { showLoginPromptModal } from 'models/ui/actions'
import { PARAM_SAVEONFIRSTRENDER } from './constants'

const locationMiddleware = (store) => (next) => (action) => {
    switch (action.type) {
        case types.FURNITURE_FILTER_UPDATE:
            // TODO make generic
            if (action.filter.collection) {
                const search =
                    action.filter.collection === '*' ? null : qs.stringify({ collection: action.filter.collection })
                store.dispatch(
                    push({
                        search,
                        hash: getHash(store.getState()),
                    }),
                )
            }
            break
        case types.OPEN_COMPOSITION:
            if (action.compositionId === -1) {
                const selectedSceneid = getSelectedId(store.getState())
                store.dispatch(
                    push({
                        pathname: '/design',
                        search: getSearch(store.getState()),
                        hash: `${action.compositionId}/${selectedSceneid}`,
                    }),
                )
            } else {
                const comp = getCompositionsData(store.getState()).find((c) => c.id === action.compositionId)
                const sceneId = comp ? comp.sceneId : null
                store.dispatch(
                    push({
                        pathname: '/design',
                        search: getSearch(store.getState()),
                        hash: `${action.compositionId}${sceneId ? `/${sceneId}` : ''}`,
                    }),
                )
            }
            break
        case types.RENDERER_READY: {
            const debugModelUrl = getDebugFurnitureModelUrl(store.getState())
            let debugFurnitureId
            if (debugModelUrl) {
                debugFurnitureId = 1
            } else {
                debugFurnitureId = getDebugFurnitureId(store.getState())
            }
            if (debugFurnitureId) {
                store.dispatch(
                    clickPlaceRenderItem(-1, debugFurnitureId, {
                        id: debugFurnitureId,
                        heading: 0,
                        renderType: FURNITURE_ITEM,
                    }),
                )
            }
            break
        }
        case types.LOGOUT_USER: {
            const redirect = getDefaultRedirectUrl()
            reset().then(() => {
                window.location.href = `${getApiPrefix()}/auth/logout?redirectUrl=${redirect}`
            })
            break
        }
        case types.RELOAD_PAGE:
            window.location.reload()
            break
        case types.REQUEST_LOGIN_PAGE: {
            const { getState, dispatch } = store

            tracker.click(`DecorateRoom.SignupLogin.${action.isSignup ? 'Signup' : 'Login'}`)

            if (getIsIFrame()) {
                // Add resume param to the history
                const nextSearch = new URLSearchParams(getSearch(getState()))
                nextSearch.set('resume', 'true')
                dispatch(
                    push({
                        search: nextSearch.toString(),
                        hash: getHash(getState()),
                    }),
                )

                // Save changes locally
                dispatch(saveSelectedCompositionToLocalStorage())
                // Redirect to login/signup with return to DYH in the url
                const returnUrl = getDesignLabReturnUrl()
                const region = getPathRegion()
                const nextUrl = makeLoginUrl(returnUrl, region, action.isSignup, true)
                window.open(nextUrl, '_top')
            } else {
                // Stay in sugarcube (legacy path)
                dispatch(push(`/${action.isSignup ? 'signup' : 'login'}`))
            }
            dispatch(showLoginPromptModal(false))
            break
        }
        case types.RECEIVE_SAVE_COMPOSITION: {
            const state = store.getState()
            // Clear the autosave param after saving
            if (getSaveOnFirstRender(state)) {
                const nextSearch = new URLSearchParams(getSearch(state))
                nextSearch.delete(PARAM_SAVEONFIRSTRENDER)
                store.dispatch(
                    push({
                        search: nextSearch.toString(),
                        hash: getHash(state),
                    }),
                )
            }
            break
        }
        default:
            break
    }
    return next(action)
}

export default locationMiddleware
